import React, { useEffect, useState } from 'react'
import { IBaseDynamicFormElement } from '../Form/DynamicForm'
import { Autocomplete, TextField, Box } from '@mui/material';
import Countries, { ICountry } from '../../features/locations/Countrries';

export default function SelectCountry(props: IBaseDynamicFormElement) {

    const { 
        id, 
        label, 
        fullWidth, 
        handleOnChange, 
        data, 
    } = props

    const countries = Countries.list()

    const handleCountryChange = (event: any, newValue: ICountry | null) => {
       handleOnChange(id, newValue ? newValue.value : null)
    }

    const selectedCountry = Countries.returnCountryBasedByValue(data.value)

    return (
        <Autocomplete
            options={countries}
            getOptionLabel={(option: ICountry) => `${option.flag} ${option.name}`}
            renderOption={(props, option: ICountry) => (
                <Box component="li" {...props}>
                {option.flag} {option.name}
                </Box>
            )}
            renderInput={(params) => (
                <TextField {...params} label={label ? label : "Select a country"} placeholder="Search..." />
            )}
            isOptionEqualToValue={(option, value) => option.value === value.value}
            onChange={handleCountryChange}
            value={selectedCountry}
            fullWidth={fullWidth}
        />
    );
}